import type { ReactNode } from 'react';

export interface FieldChromeProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  optional?: boolean | undefined;
  id: string;
  children: ReactNode;
}

/** Shared label/hint/error scaffold used by every form control. */
export function FieldChrome({
  label,
  hint,
  error,
  optional,
  id,
  children,
}: FieldChromeProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      {label !== undefined && (
        <label
          className="flex items-center justify-between text-sm font-semibold text-foreground"
          htmlFor={id}
        >
          <span>{label}</span>
          {optional && <span className="text-xs text-muted-foreground font-normal">Optional</span>}
        </label>
      )}
      {children}
      {error !== undefined && error !== '' ? (
        <span className="text-xs text-destructive mt-0.5" role="alert">
          {error}
        </span>
      ) : (
        hint !== undefined && <span className="text-xs text-muted-foreground mt-0.5">{hint}</span>
      )}
    </div>
  );
}
